import "./Navbar.css";
import "./../Home/BannerSection/Banner.css";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { createPortal } from "react-dom";
import Login from "./../LoginRegister/Login";
import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { Modal, Tab, Nav, Button } from "react-bootstrap";
import $ from "jquery";
import backBtn from "./../../Assets/Icons/back.png";
import logo from "./../../Assets/Image/LogoTransparentBrown.png";
import logowhite from "./../../Assets/Image/LogoTransparent.png";
import { useSelector, useDispatch } from "react-redux";
import { X } from "lucide-react";
import {
  changeLoadFalse,
  changeLoadTrue,
  openRegisterPageFalse,
  closeForgetPassword,
  openForgetPassword,
} from "../../actions/index";
import searchIcont from "./../../Assets/Icons/searchIcon2.png";
import searchIcontCoffee from "./../../Assets/Icons/searchIcon.png";
import searchair from "./../../Assets/Image/SearchAir.png";
import loginImg from "./../../Assets/Image/login.png";
import loginDesktopImg from "./../../Assets/Image/login-Desktop.png";
import homeImg from "./../../Assets/Image/home.png";
import menuImg from "./../../Assets/Image/menu.png";
import shoppingCart from "./../../Assets/Icons/shopping-bag.png";
import userDefaultImg from "./../../Assets/Icons/user-default -propic.png";
import leo from "./../../Assets/Image/Leo.png";
import test from "./../../Assets/Image/PastaOffer.jpg";
import fuchka from "./../../Assets/Image/1 51.png";
import star from "./../../Assets/Icons/starCoffe.png";
import PKB from "./../../Assets/Image/PKB.png";
import pasta from "./../../Assets/Image/Pasta 1.png";
import search from "./../../Assets/Icons/searchIcon.png";
import Cart from "../Cart/Cart";
import Test9 from "../../Test9";
import SidebarLogin from "./SidebarLogin";
import Notification from "../../components/Navbar/Notification";
import axios from "axios";
import { Link } from "react-router-dom";
import FoodModal from "../Home/FoodSelection/FoodModal";
import FoodModalUpdate from "../Cart/Components/FoodModalUpdate/FoodModalUpdate";
import searchIcon from "../../Assets/Icons/searchIcon.png";
import { Menu, MenuItem } from "@mui/material";
import { sliceText } from "../../utils/sliceText";
import { getFoodStatus } from "../../utils/getFoodStatus";
import StarRating from "../../components/Navbar/Rating";
import Rating from "react-rating";
import StatusCapsule from "../Restaurant/MenuSelection/Components/StatusCapsule";
import UnauthorizeLogin from "../../components/FoodModal/UnauthorizeLogin";
import useLoginState from "../../components/FoodModal/useLoginState";
import SearchStepNav from "./components/SearchStepNav";
import SearchLocationStep from "./components/SearchLocationStep";
import SearchDistanceLabel from "./components/SearchDistanceLabel";
import GoTasteSearchBar from "./components/GoTasteSearchBar";
import {
  fetchLocationFromCoords,
  fetchLocationSuggestions,
  fetchSearchResults,
  normalizeLocationSelection,
} from "./utils/searchApi";

const Navbar = (props) => {
  const apiAddress = process.env.REACT_APP_SECRET;
  const currentState = useSelector((state) => state.changeLoad);
  const isRegisterPage = useSelector((state) => state.openRegisterPage);
  const isReloadPage = useSelector((state) => state.testReducers);
  const forgetPasswordToggle = useSelector((state) => state.forgetPassword);
  const dispatch = useDispatch();
  const [userVal, setUserValue] = useState("");
  const [profileImage, setProfileImage] = useState("");
  const navigate = useNavigate();
  const [navbarOnTop, setNavbarOnTop] = useState(true);
  const [scrollValue, setscrollValue] = useState(0);
  const [slideUp, setSlideUp] = useState(false);
  const [searchModalSlideUp, setSearchModalSlideUp] = useState(false);
  const navbarTopRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [allSelected, setAllSelected] = useState(false);
  const [foodSelected, setFoodSelected] = useState(false);
  const [resturantSelected, setRestaurantSelected] = useState(false);
  const [locationError, setLocationError] = useState("");
  const [show, setShow] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const searchDialogdivRef = useRef(null);
  const searchModalRef = useRef(null);
  const [searchInput, setSearchInput] = useState("");
  const [category, setCategory] = useState("");
  const [defaultColor, setDefaultColor] = useState(false);
  const [Flag, setFlag] = useState(false);
  const [userId, setUserId] = useState("");
  const [SearchData, setSearchData] = useState({
    searchFoodView: [],
    searchRestaurantView: [],
  });
  const [isDataFound, setIsdataFound] = useState("");
  const [TyepedData, setTypedData] = useState(false);
  const [SearchString, setSearchString] = useState();
  const [orderDetails, setOrderDetails] = useState(null);
  const [loading, setIsLoading] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(false);
  const [selectedItemImage, setSelectedItemImage] = useState([]);
  const [showModalCard, setShowModalCard] = useState(false);
  const [showUpdateFoodModalCard, setShowUpdateFoodModalCard] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const inputRef = useRef(null);
  const [passwordView, setPasswordView] = useState(false);
  const [isForgetPasswordSubmited, setisForgetPasswordSubmited] =
    useState(false);
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [forgetPassword, setforgetPassword] = useState(false);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [showOutOfHourModal, setShowOutOfHourModal] = useState(false);
  const [showUnavailableReasonModal, setShowUnavailableReasonModal] =
    useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [orderDetailsEdit, setOrderDetailsEdit] = useState(null);
  const [selectedItemIdEdit, setSelectedItemIdEdit] = useState(false);
  const [selectedItemImageEdit, setSelectedItemImageEdit] = useState([]);
  const [cartData, setCartData] = useState([]);
  const cartCount = useSelector((state) => state.cart.totalCount);
  const [registerSuccess, setRegisterSuccess] = useState(false);
  const [
    showBottomBarDueToCartAddInSearch,
    setShowBottomBarDueToCartAddInSearch,
  ] = useState(false);
  const [searchStep, setSearchStep] = useState("location");
  const [locationQuery, setLocationQuery] = useState("");
  const [locationLabel, setLocationLabel] = useState("");
  const [searchLocation, setSearchLocation] = useState(null);
  const [locationSuggestions, setLocationSuggestions] = useState([]);
  const [loadingSuggestions, setLoadingSuggestions] = useState(false);
  const [loadingCurrentLocation, setLoadingCurrentLocation] = useState(false);

  const showRef = useRef(show);
  const modalBodyRef = useRef(null);
  useEffect(() => {
    if (!show || !modalBodyRef.current) return;

    const handleModalScroll = () => {
      // Hide bottom bar on scroll *inside modal*, unless forced visible
      if (!showBottomBarDueToCartAddInSearch) {
        setSlideUp(true);
      }
    };

    const modalBody = modalBodyRef.current;
    modalBody.addEventListener("scroll", handleModalScroll, { passive: true });
    return () => modalBody.removeEventListener("scroll", handleModalScroll);
  }, [show, showBottomBarDueToCartAddInSearch]);
  useEffect(() => {
    showRef.current = show;
  }, [show]);
  // Reset flag when search modal closes
  useEffect(() => {
    if (!show) {
      setShowBottomBarDueToCartAddInSearch(false);
    }
  }, [show]);

  useEffect(() => {
    if (!showModal) return undefined;

    const scrollY = window.scrollY;
    document.documentElement.classList.add("search-overlay-open");
    document.body.classList.add("search-overlay-open");
    document.body.style.top = `-${scrollY}px`;

    return () => {
      document.documentElement.classList.remove("search-overlay-open");
      document.body.classList.remove("search-overlay-open");
      document.body.style.top = "";
      window.scrollTo(0, scrollY);
    };
  }, [showModal]);

  useEffect(() => {
    if (!show && !showModal) return;

    const scrollTargets = [modalBodyRef.current, searchModalRef.current].filter(
      Boolean,
    );
    scrollTargets.forEach((element) => {
      element.scrollTo(0, 0);
    });
  }, [show, showModal, searchStep]);

  useEffect(() => {
    if (!show && !showModal) {
      setSearchStep("location");
      setLocationQuery("");
      setSearchLocation(null);
      setLocationLabel("");
      setLocationSuggestions([]);
      setLocationError("");
    }
  }, [show, showModal]);

  useEffect(() => {
    if (searchStep !== "location") return undefined;

    if (!locationQuery || locationQuery.trim().length < 2) {
      setLocationSuggestions([]);
      return undefined;
    }

    if (searchLocation && locationQuery === searchLocation.label) {
      return undefined;
    }

    const timer = setTimeout(async () => {
      setLoadingSuggestions(true);
      try {
        const items = await fetchLocationSuggestions(apiAddress, locationQuery);
        setLocationSuggestions(items);
      } catch (error) {
        console.error("Location suggestion error:", error);
        setLocationSuggestions([]);
      } finally {
        setLoadingSuggestions(false);
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [locationQuery, searchStep, searchLocation, apiAddress]);

  const closeEditModal = () => {
    setShowEdit(false);
    setShowUpdateFoodModalCard(false);
    window.location.href = window.location.href; // Refresh the page to reflect any changes made in the cart
  };

  const loadSearchResults = async (searchStr = "") => {
    setLoadingSearch(true);
    try {
      const data = await fetchSearchResults(apiAddress, {
        searchStr,
        searchLocation,
      });

      if (
        !data?.searchFoodView?.length &&
        !data?.searchRestaurantView?.length
      ) {
        setIsdataFound("No Data Found");
      } else {
        setIsdataFound("");
      }

      setSearchData({
        searchFoodView: data?.searchFoodView || [],
        searchRestaurantView: data?.searchRestaurantView || [],
      });
      setTypedData(true);
      setFlag((current) => !current);
    } catch (error) {
      console.error("Search error:", error);
      setIsdataFound("No Data Found");
    } finally {
      setLoadingSearch(false);
    }
  };

  const handleClearSearch = () => {
    setSearchString("");
    setTypedData(false);
    loadSearchResults("");

    if (inputRef.current) {
      inputRef.current.focus({ preventScroll: true });
    }
  };

  const handleInputChange = (event) => {
    const { value } = event.target;
    if (searchStep !== "results") return;

    setTypedData(true);
    setSearchString(value);

    if (!value) {
      setSearchData({
        searchFoodView: [],
        searchRestaurantView: [],
      });
      setIsdataFound("");
    }
  };

  useEffect(() => {
    if (searchStep !== "results") return undefined;

    const timer = setTimeout(() => {
      loadSearchResults(SearchString || "");
    }, 300);

    return () => clearTimeout(timer);
  }, [SearchString, searchStep, searchLocation]);

  //  test start
  const handleClickOutside = (event) => {
    if (searchModalRef.current?.contains(event.target)) {
      return;
    }

    if (
      searchDialogdivRef.current &&
      !searchDialogdivRef.current.contains(event.target)
    ) {
      setShowModal(false);
    }
  };

  useEffect(() => {
    if (props.from !== undefined) {
      setDefaultColor(true);
    }
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const openLocationStep = ({ desktop = false, mobile = false } = {}) => {
    setSearchStep("location");
    if (desktop) setShowModal(true);
    if (mobile) setShow(true);
  };

  const goToResultsStep = (
    filter = "All",
    { desktop = false, mobile = false } = {},
  ) => {
    setSearchStep("results");
    setAllSelected(filter === "All");
    setFoodSelected(filter === "Food");
    setRestaurantSelected(filter === "Restaurant");
    if (desktop) setShowModal(true);
    if (mobile) setShow(true);
    loadSearchResults(SearchString || "");
  };

  const skipLocationStep = (options = {}) => {
    setSearchLocation(null);
    setLocationLabel("Searching everywhere");
    setLocationError("");
    setLocationSuggestions([]);
    goToResultsStep("All", options);
  };

  const handleSelectLocation = (item) => {
    const normalized = normalizeLocationSelection(item);
    if (!normalized) {
      setLocationError("Unable to use this location. Try another.");
      return;
    }

    setSearchLocation(normalized);
    setLocationLabel(normalized.label);
    setLocationQuery(normalized.label);
    setLocationSuggestions([]);
    setLocationError("");
  };

  const handleClearLocationSelection = () => {
    setSearchLocation(null);
    setLocationLabel("");
    setLocationQuery("");
    setLocationSuggestions([]);
  };

  const handleUseCurrentLocation = () => {
    if (!navigator.geolocation) {
      setLocationError("Geolocation is not supported by your browser.");
      return;
    }

    setLoadingCurrentLocation(true);
    setLocationError("");

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        try {
          const data = await fetchLocationFromCoords(
            apiAddress,
            position.coords.latitude,
            position.coords.longitude,
          );
          const normalized = normalizeLocationSelection(data);

          if (!normalized) {
            setLocationError("Could not resolve your current location.");
            return;
          }

          setSearchLocation(normalized);
          setLocationLabel(normalized.label);
          setLocationQuery(normalized.label);
          setLocationSuggestions([]);
        } catch (error) {
          console.error("Current location error:", error);
          setLocationError("Could not fetch your location. Please try again.");
        } finally {
          setLoadingCurrentLocation(false);
        }
      },
      () => {
        setLocationError("Please enable location access to use this feature.");
        setLoadingCurrentLocation(false);
      },
    );
  };

  const continueFromLocation = (options = {}) => {
    if (!searchLocation) return;
    goToResultsStep("All", options);
  };

  const handleStepClick = (stepKey) => {
    if (stepKey === "location") {
      openLocationStep({ desktop: showModal, mobile: show });
      return;
    }

    if (searchStep === "results") {
      goToResultsStep("All", { desktop: showModal, mobile: show });
    }
  };

  function handleSearchIcon() {
    if (showModal && searchStep === "results") {
      setShowModal(false);
      return;
    }
    openLocationStep({ desktop: true });
  }

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.pageYOffset;
      setIsVisible(scrollPosition === 0);
      setShowBottomBarDueToCartAddInSearch(false);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  function handleShow() {
    openLocationStep({ mobile: true });
  }

  useEffect(() => {
    // Check if user is authenticated
    const gotasteClienttoken = localStorage.getItem("gotasteClienttoken");
    let decoded = null;
    if (gotasteClienttoken != null) {
      try {
        decoded = jwt_decode(gotasteClienttoken);
      } catch (error) {}
      if (decoded != null || decoded != undefined) {
        setUserValue(decoded.UserName);
        setProfileImage(decoded.ProfileImage);
        setUserId(decoded.UserId);
      }
    }

    // previous scroll logic: had issue on ios devices
    // window.addEventListener("scroll", (event) => {
    //   const filterBarRect = navbarTopRef?.current?.getBoundingClientRect();

    //   if (filterBarRect !== undefined) {
    //     const isAboveViewport = filterBarRect.top === 0 ? true : false;
    //     setNavbarOnTop(isAboveViewport);
    //     var top = filterBarRect.top * -1;
    //     var scrollval = scrollValue * -1;
    //     if (top > scrollval) {
    //       setSlideUp(true);
    //     } else if (top <= 0) {
    //       setSlideUp(false);
    //     } else {
    //       setSlideUp(false);
    //     }

    //     var s = filterBarRect.top;
    //     setscrollValue(s);
    //   }
    // });
  });

  // new scroll logic to overcome ios issues
  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Always show navbar when at the very top
      if (currentScrollY <= 0) {
        setSlideUp(false);
        setNavbarOnTop(true);
      }
      // Hide navbar when scrolling DOWN (past 10px)
      else if (currentScrollY > lastScrollY && currentScrollY > 10) {
        setSlideUp(true);
        setNavbarOnTop(false);
      }
      // Show navbar when scrolling UP
      else if (currentScrollY < lastScrollY) {
        setSlideUp(false);
        setNavbarOnTop(false);
      }

      // Remember where we were
      lastScrollY = currentScrollY;
    };

    // Add scroll listener (optimized for mobile)
    window.addEventListener("scroll", handleScroll, { passive: true });

    // Clean up when component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const goToHome = () => {
    window.location.href = `/`;
  };

  const hideModalInfo = () => {
    setLoginModalOpen(false);
    dispatch(changeLoadFalse());
    dispatch(openRegisterPageFalse());
    window.$("#exampleModalCenter").modal("hide");
    // window.location.reload();
  };

  const showModalInfo = () => {
    setLoginModalOpen(true);
    dispatch(changeLoadFalse());
    dispatch(openRegisterPageFalse());
    window.$("#exampleModalCenter").modal("show");
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };
  // function handleSearchIcon(){
  //     setShowModal(!showModal)
  // }

  const handleUserFound = (props) => {
    setPasswordView(props);
  };

  useEffect(() => {
    if (typeof props.handleNavbar === "function") {
      props.handleNavbar(showModal);
    }
  }, [showModal, props.handleNavbar]);

  const handleSeeMoreClick = () => {
    setShowModal(false);
    setShow(false);
  };

  const getItemDetails = (data) => {
    setIsLoading(true);
    setShowModalCard(true);
    setOrderDetails(null);
    // setIsLoading(false);
    setSelectedItemId(null);
    setSelectedItemImage([]);
    axios
      .get(
        apiAddress +
          "/api/FoodItems/GetFoodItemDetailsForOrderDetailsByItemId?ItemId=" +
          data.foodItemId,
      )
      .then((response) => {
        if (
          getFoodStatus(response?.data?.isActive, response?.data?.status) ===
          "Out of hour"
        ) {
          setShowOutOfHourModal(true);
        }

        if (
          getFoodStatus(response?.data?.isActive, response?.data?.status) ===
          "Unavailable"
        ) {
          setShowUnavailableReasonModal(true);
        }

        const updatedResponseData = {
          ...response.data,
          restaurantId: data.restaurantId,
        };

        setOrderDetails(updatedResponseData);

        setSelectedItemId(data.foodItemId);
        setSelectedItemImage(updatedResponseData);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleClose = () => setShowModalCard(false);

  useEffect(() => {
    if (
      (showModal || show) &&
      searchStep === "results" &&
      inputRef.current
    ) {
      const timer = setTimeout(() => {
        inputRef.current?.focus({ preventScroll: true });
      }, 100);

      return () => clearTimeout(timer);
    }

    return undefined;
  }, [showModal, show, searchStep]);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.removeItem("gotasteClienttoken");
    handleMenuClose();
    window.location.href = `/`;
  };

  // const getMatchedColumn = (object, searchString) => {
  //   if (!searchString) return []; // If searchString is undefined, return an empty array

  //   const keysMap = {
  //     // "keyword": "Section",
  //     "keywordtag": "Keyword Tag",
  //     "foodDetailsDescription": "Details",
  //     "foodStory": "Story",
  //     "instructionDescription": "Instruction",
  //     "foodKeyword": "Keyword"
  //   };

  //   const matchedValues = [];

  //   // Loop through the keysMap and check if the object contains any matching key
  //   Object.keys(keysMap).forEach((key) => {
  //     const text = object[key];
  //     if (text && typeof text === 'string') {
  //       const regex = new RegExp(`(${searchString})`, 'gi'); // Case-insensitive match
  //       if (regex.test(text)) { // If match is found
  //         // Create an object with the dynamic key from keysMap
  //         const matchedObject = {};
  //         matchedObject[keysMap[key]] = text;

  //         // Push the matched object into the array
  //         matchedValues.push(matchedObject);
  //       }
  //     }
  //   });

  //   return matchedValues; // Return the matched values from keysMap
  // };

  const getMatchedColumn = (object, searchString) => {
    if (!searchString) return [];

    const keysMap = {
      // "keyword": "Section",
      keywordtag: "Category",
      foodDetailsDescription: "Details",
      foodStory: "Story",
      instructionDescription: "Instruction",
      foodKeyword: "Keyword",
    };

    const matchedValues = [];

    const splitedQuery = searchString.split(" ").filter(Boolean);

    Object.keys(keysMap).forEach((key) => {
      const text = object[key];
      if (text && typeof text === "string") {
        const regex = new RegExp(`(${searchString})`, "gi");

        if (regex.test(text)) {
          const matchedObject = {};
          matchedObject[keysMap[key]] = text;
          matchedValues.push(matchedObject);
        } else {
          const wordRegex = new RegExp(`(${splitedQuery.join("|")})`, "gi");
          if (wordRegex.test(text)) {
            const matchedObject = {};
            matchedObject[keysMap[key]] = text;
            matchedValues.push(matchedObject);
          }
        }
      }
    });

    return matchedValues;
  };

  // const extractContext = (description, searchString) => {
  //   if (!searchString || !description) return ''; // If no search string or description, return empty string

  //   const regex = new RegExp(`(\\S+\\s+){0,2}(\\S*${searchString}\\S*)(\\s+\\S+){0,1}`, 'gi'); // Match the searchString and up to 2 words before and after
  //   const match = description.match(regex);

  //   if (match) {
  //     // Return the matched context with '...' before and after
  //     return `...${match[0].trim()}...`;
  //   }

  //   return ''; // If no match found, return an empty string
  // };

  const extractContext = (description, searchString) => {
    if (!searchString || !description) return "";

    const searchTokens = searchString?.split(" ").filter(Boolean);
    const regex = new RegExp(`(${searchTokens.join("|")})`, "gi");

    const match = description.match(regex);

    if (match) {
      return `...${match[0].trim()}...`;
    }

    return "";
  };

  // const highlightMatch = (text, searchString) => {
  //   if (!searchString) return text; // If searchString is undefined, return the original text
  //   const regex = new RegExp(`(${searchString})`, 'gi'); // Case-insensitive match
  //   return text?.split(regex).map((part, index) =>
  //     part.toLowerCase() === searchString.toLowerCase() ? (
  //       <span key={index} style={{ backgroundColor: '#ffff00', color: "#000000" }}>
  //         {part}
  //       </span>
  //     ) : (
  //       part
  //     )
  //   );
  // };

  const highlightMatch = (text, searchString) => {
    if (!searchString) return text;

    const searchTokens = searchString?.split(" ").filter(Boolean);
    const regex = new RegExp(`(${searchTokens.join(" ")})`, "gi");

    if (regex?.test(text)) {
      return text?.split(regex).map((part, index) =>
        part.toLowerCase() === searchString.toLowerCase() ? (
          <span
            key={index}
            style={{ backgroundColor: "#ffff00", color: "#000000" }}
          >
            {part}
          </span>
        ) : (
          part
        ),
      );
    } else {
      const wordRegex = new RegExp(`(${searchTokens.join("|")})`, "gi");
      return text?.split(wordRegex).map((part, index) =>
        searchTokens?.some(
          (token) => part.toLowerCase() === token.toLowerCase(),
        ) ? (
          <span
            key={index}
            style={{ backgroundColor: "#ffff00", color: "#000000" }}
          >
            {part}
          </span>
        ) : (
          part
        ),
      );
    }
  };

  const setSearchConditionOnClick = () => {
    openLocationStep({ mobile: true });
  };

  const moibleSearchBarClicked = (event) => {
    const isSearchCriteria = event.target.closest(".search-criteria");

    if (!isSearchCriteria) {
      openLocationStep({ mobile: true });
    }
  };

  //--update modal opening functionality--
  const getIsFoodItemExistsInCart = async (foodItemId, restaurantId) => {
    try {
      if (userId) {
        if (foodItemId !== null) {
          const response = await axios.get(
            `${apiAddress}/api/Cart/GetFoodItemFromCartByUserIdAndRestaurantIdAndFoodItemId?userId=${userId}&restaurantId=${restaurantId}&foodItemId=${foodItemId}`,
          );
          return response.data;
        } else {
          const response = await axios.get(
            `${apiAddress}/api/Cart/GetFoodItemFromCartByUserIdAndRestaurantIdAndFoodItemId?userId=${userId}&restaurantId=${restaurantId}&foodItemId=${foodItemId}`,
          );
          return response.data;
        }
      }
    } catch (error) {
      console.error("Error while checking if food item already exist", error);
    }
  };

  // handle search bar food item
  const foodItemGotClicked = async (d) => {
    // when user login (two option 1.show food item details, 2.if already in cart show update modal)
    if (userId) {
      // check fooditem is in cart or not
      const result = await getIsFoodItemExistsInCart(
        d.foodItemId,
        d.restaurantId,
      );
      if (result !== "") {
        // already in cart show edit modal
        getItemDetailsForEdit(d);
      } else {
        // show food item modal
        getItemDetails(d);
      }
    }
    // when user not login
    else {
      // show food item modal
      getItemDetails(d);
    }
  };

  const getItemDetailsForEdit = async (data) => {
    try {
      setShowEdit(true);
      setEditLoading(true);

      const response = await axios.get(
        `${apiAddress}/api/FoodItems/GetFoodItemDetailsForOrderDetailsByItemId?ItemId=${
          data.id ? data.id : data.foodItemId
        }`,
      );

      setOrderDetailsEdit(response.data);
      setSelectedItemIdEdit(response.data.id);
      setSelectedItemImageEdit(response.data.foodItemImages);
      setEditLoading(false);
      setShowUpdateFoodModalCard(true);
    } catch (error) {
      setEditLoading(false);
      console.log("Error while fetching fooditem details from Navbar", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (userId) {
          const response = await axios.get(
            `${process.env.REACT_APP_SECRET}/api/Cart/GetCartDataByUserId?userId=${userId}`,
          );
          setCartData(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [userId, cartCount]);

  const { loginModalOpen: openLoginModal } = useLoginState();

  return (
    <div className="Navbar-custom">
      {/* <div ref={navbarTopRef}></div> */}

      {/* Navbar & Search for desktop device */}
      <div className="desktopDisplay">
        <div
          className={`navbarGoTaste  ${
            navbarOnTop
              ? defaultColor
                ? "backgroundWhite"
                : "backgroundTranparent"
              : "backgroundWhite"
          } ${slideUp ? "slideDown" : " slideUp "}`}
        >
          {/* GoTaste logo--navbar left hamburger */}
          <div className="brand d-flex align-items-center">
            <button
              class="btn me-4"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasExample"
              aria-controls="offcanvasExample"
            >
              {defaultColor ? (
                <div
                  className="btn btn-buyNow w-100"
                  style={{ color: "white" }}
                >
                  Sign Up
                </div>
              ) : (
                <i
                  class={`fa-solid fa-bars text-light   ${
                    navbarOnTop
                      ? defaultColor
                        ? "text-dark"
                        : "text-light"
                      : "text-dark"
                  }`}
                ></i>
              )}
            </button>

            {defaultColor ? (
              <button
                className={` brandname ${
                  navbarOnTop
                    ? defaultColor
                      ? "brandname-color-coffee"
                      : "brandname-color-white"
                    : "brandname-color-coffee"
                }`}
                style={{ width: "150px" }}
              >
                <img src={logo} alt="" style={{ width: "3rem" }} /> Go{" "}
                <b>Taste</b>
              </button>
            ) : (
              <>
                <a
                  className={` brandname ${
                    navbarOnTop
                      ? defaultColor
                        ? "brandname-color-coffee"
                        : "brandname-color-white"
                      : "brandname-color-coffee"
                  }`}
                  href="/"
                >
                  {navbarOnTop ? (
                    <div style={{ width: "150px" }}>
                      <img src={logowhite} alt="" style={{ width: "3rem" }} />{" "}
                      Go <b>Taste</b>
                    </div>
                  ) : (
                    <div style={{ width: "150px" }}>
                      <img src={logo} alt="" style={{ width: "3rem" }} /> Go{" "}
                      <b>Taste</b>
                    </div>
                  )}
                </a>
              </>
            )}
          </div>
            {/* ---Search UI with search result modal --- */}
            <div
              className="navbar-search"
              ref={searchDialogdivRef}
            >
              {!defaultColor && (
                <div className="searchInput">
                  <GoTasteSearchBar
                    showModal={showModal}
                    searchStep={searchStep}
                    navbarOnTop={navbarOnTop}
                    defaultColor={defaultColor}
                    searchIcon={searchIcont}
                    searchString={SearchString}
                    locationLabel={
                      searchLocation ? locationLabel : ""
                    }
                    onOpenSearch={() => openLocationStep({ desktop: true })}
                    onSearchToggle={handleSearchIcon}
                  />
                </div>
              )}

            {/* Search result area */}
            {showModal && !searchModalSlideUp
              ? createPortal(
              <>
                <div
                  className="search-modal-backdrop"
                  onClick={() => setShowModal(false)}
                  aria-hidden="true"
                />
                <div
                  id="searchDialogId"
                  className="search-modal-shell"
                  ref={searchModalRef}
                >
                <div className={`searchDialog search-modal-card${searchStep === "results" ? " search-modal-card--results" : ""}`}>
                  <SearchStepNav
                    currentStep={searchStep}
                    locationLabel={locationLabel}
                    searchKeyword={SearchString}
                    onStepClick={handleStepClick}
                    onSearchChange={handleInputChange}
                    onClearSearch={handleClearSearch}
                    inputRef={inputRef}
                  />

                  {searchStep === "location" ? (
                    <SearchLocationStep
                      locationQuery={locationQuery}
                      onLocationQueryChange={setLocationQuery}
                      locationSuggestions={locationSuggestions}
                      loadingSuggestions={loadingSuggestions}
                      selectedLocation={searchLocation}
                      onSelectSuggestion={handleSelectLocation}
                      onClearSelection={handleClearLocationSelection}
                      onUseCurrentLocation={handleUseCurrentLocation}
                      loadingCurrentLocation={loadingCurrentLocation}
                      locationError={locationError}
                      onContinue={() => continueFromLocation({ desktop: true })}
                      onSkip={() => skipLocationStep({ desktop: true })}
                    />
                  ) : (
                    <>
                  <ul className="nav nav-tabs pt-3" id="myTab" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className={`nav-link ${allSelected ? "active" : ""}`}
                        id="home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#all"
                        type="button"
                        role="tab"
                        aria-controls="home"
                        aria-selected={allSelected}
                        onClick={() => {
                          setAllSelected(true);
                          setFoodSelected(false);
                          setRestaurantSelected(false);
                        }}
                      >
                        All
                      </button>
                    </li>

                    <li className="nav-item" role="presentation">
                      <button
                        className={`nav-link ${foodSelected ? "active" : ""}`}
                        id="profile-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#food"
                        type="button"
                        role="tab"
                        aria-controls="profile"
                        aria-selected={foodSelected}
                        onClick={() => {
                          setAllSelected(false);
                          setFoodSelected(true);
                          setRestaurantSelected(false);
                        }}
                      >
                        Food
                      </button>
                    </li>

                    <li className="nav-item" role="presentation">
                      <button
                        className={`nav-link ${resturantSelected ? "active" : ""}`}
                        id="contact-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#restaurant"
                        type="button"
                        role="tab"
                        aria-controls="contact"
                        aria-selected={resturantSelected}
                        onClick={() => {
                          setAllSelected(false);
                          setFoodSelected(false);
                          setRestaurantSelected(true);
                        }}
                      >
                        Restaurant
                      </button>
                    </li>
                  </ul>

                  {/* Tab-Content */}
                  <div class="tab-content" id="myTabContent">
                    {/* All tab content - desktop*/}
                    <div
                      class={`tab-pane fade ${
                        allSelected ? "show active" : ""
                      }  `}
                      id="all"
                      role="tabpanel"
                      aria-labelledby="home-tab"
                    >
                      <p className="navbar_search-filter-label">
                        Top 5 Suggested Foods & Restaurants
                      </p>
                      {SearchData?.searchFoodView?.slice(0, 3)?.map((d, i) => {
                        return (
                          <>
                            <div
                              className="d-flex align-items-center pt-2"
                              style={{ minHeight: "2.5rem", cursor: "pointer" }}
                              onClick={() => {
                                foodItemGotClicked(d);
                              }}
                            >
                              {/* Item Image */}
                              <div className="searchContentMargin">
                                <img
                                  src={d.itemImagePath}
                                  alt="img"
                                  className="searchDialogImg"
                                ></img>
                              </div>

                              {/* Item Name, description, RestaurantName and ratings */}
                              <div className="d-flex flex-column searchContentMargin">
                                <div className="searchText searchTitile d-flex gap-2">
                                  {/* Food Item Name */}
                                  <span>
                                    {highlightMatch(
                                      d.foodItemName,
                                      SearchString,
                                    )}{" "}
                                    <span
                                      style={{
                                        color: "gray",
                                        fontSize: "13px",
                                      }}
                                    >
                                      £{d.price}
                                    </span>
                                  </span>

                                  {/* FoodLabel */}
                                  <div className="searchLabel">
                                    <p className="searchText">Food</p>
                                  </div>

                                  {getFoodStatus(d.isActive, d.status) ===
                                    "Out of hour" && (
                                    <StatusCapsule
                                      status={getFoodStatus(
                                        d.isActive,
                                        d.status,
                                      )}
                                    />
                                  )}
                                </div>

                                {/* Food item rating */}
                                <div
                                  className="rating-Font d-flex gap-1 align-items-center starRating"
                                  data-bs-toggle="modal"
                                  data-bs-target="#staticBackdrop"
                                >
                                  <Rating
                                    className="ratingStar"
                                    initialRating={Number(4.5)}
                                    emptySymbol="far fa-star icon-color"
                                    fullSymbol="fas fa-star icon-color"
                                    readonly
                                  ></Rating>
                                  4.5
                                  <SearchDistanceLabel value={d.distance} hasLocation={Boolean(searchLocation)} />
                                </div>

                                {extractContext(d.description, SearchString) ? (
                                  <div className="d-flex flex-row ">
                                    <p
                                      className="searchText searchratingText"
                                      style={{
                                        marginBottom: "0px",
                                        color: "#80615b",
                                      }}
                                    >
                                      {highlightMatch(
                                        extractContext(
                                          d.description,
                                          SearchString,
                                        ),
                                        SearchString,
                                      )}
                                    </p>
                                  </div>
                                ) : (
                                  <div className="d-flex flex-row">
                                    <p
                                      className="searchText searchratingText"
                                      style={{
                                        marginBottom: "0px",
                                        color: "#80615b",
                                      }}
                                    >
                                      {d.description.length > 100
                                        ? d.description.slice(0, 36) + "..."
                                        : d.description}
                                    </p>
                                  </div>
                                )}
                                {/* Restaurant Name for all tab */}
                                <div>
                                  <p
                                    className="searchText searchratingText d-flex flex-row gap-2"
                                    style={{
                                      marginBottom: "0px",
                                      color: "#80615b",
                                    }}
                                  >
                                    <span>{d.restaurantName}</span>
                                    <div style={{ marginTop: "-2px" }}>
                                      <StarRating
                                        starImage={star}
                                        rating={4.5}
                                      />
                                    </div>
                                  </p>
                                </div>
                              </div>

                              {
                                // d?.matchedText &&
                                // <div className='searchLabel matched-text'>
                                //   <p className='searchText'>
                                //     {highlightMatch(sliceText(d?.matchedText?.split(",")[0], 15), SearchString)}
                                //   </p>
                                // </div>
                              }

                              {/* Showing matched field  */}
                              <div
                                className="d-flex gap-1 ml-2"
                                style={{ marginLeft: "auto", maxWidth: "40%" }}
                              >
                                {highlightMatch(d.foodItemName, SearchString)
                                  .length <= 1 &&
                                  !extractContext(
                                    d.description,
                                    SearchString,
                                  ) &&
                                  getMatchedColumn(d, SearchString).map(
                                    (matchedItem, index) => {
                                      const [key, value] =
                                        Object.entries(matchedItem)[0];
                                      return (
                                        <div
                                          className="ms-auto matched-text"
                                          key={index}
                                        >
                                          {/* Showing details header from db */}
                                          {key === "Details" && (
                                            <p className="mb-0">
                                              {d.foodDetailsHeader}
                                            </p>
                                          )}
                                          {/* If Instruction matched, then only show it */}
                                          {key === "Instruction" && (
                                            <p className="mb-0">
                                              {d.foodDetailsHeader}
                                            </p>
                                          )}

                                          {/* Else show header  */}
                                          {key !== "Details" &&
                                            key !== "Instruction" && (
                                              <p className="mb-0">{key}</p>
                                            )}
                                          <p className="mb-0">
                                            {highlightMatch(
                                              extractContext(
                                                value,
                                                SearchString,
                                              ),
                                              SearchString,
                                            )}
                                          </p>
                                        </div>
                                      );
                                    },
                                  )}
                              </div>
                            </div>
                            <hr />
                          </>
                        );
                      })}

                      {SearchData?.searchRestaurantView
                        ?.slice(0, 2)
                        ?.map((d, i) => {
                          return (
                            <>
                              <a
                                href={`/${d.urlName}`}
                                className="d-flex align-items-center pt-2 restaurant-link"
                              >
                                {/* Restaurant Logo */}
                                <div className="searchContentMargin">
                                  <img
                                    src={d.restaurantLogo}
                                    alt="img"
                                    className="searchDialogImg"
                                  ></img>
                                </div>

                                {/* Details */}
                                <div className="d-flex flex-column searchContentMargin">
                                  <span
                                    className="searchText searchTitile"
                                    style={{ textDecoration: "none" }}
                                  >
                                    <div className="d-flex gap-2">
                                      <span>
                                        {highlightMatch(d.name, SearchString)}
                                      </span>

                                      <div className="searchLabelRestaurant">
                                        <p className="searchText">Restaurant</p>
                                      </div>
                                    </div>
                                  </span>

                                  {/* Ratings */}
                                  <div
                                    className="rating-Font d-flex gap-1 align-items-center starRating rating-color"
                                    data-bs-toggle="modal"
                                    data-bs-target="#staticBackdrop"
                                  >
                                    <Rating
                                      className="ratingStar"
                                      initialRating={Number(4.5)}
                                      emptySymbol="far fa-star icon-color"
                                      fullSymbol="fas fa-star icon-color"
                                      readonly
                                    ></Rating>
                                    4.5
                                    <SearchDistanceLabel value={d.distanceInKm} hasLocation={Boolean(searchLocation)} />
                                  </div>

                                  <div className="d-flex flex-row">
                                    <p
                                      className="searchText searchratingText"
                                      style={{
                                        marginBottom: "0px",
                                        color: "#80615b",
                                      }}
                                    >
                                      {highlightMatch(
                                        d.restaurantCategories,
                                        SearchString,
                                      )}
                                    </p>
                                  </div>

                                  <div>
                                    <p
                                      style={{
                                        marginBottom: "0px",
                                        color: "#80615b",
                                        fontSize: "14px",
                                      }}
                                    >
                                      {sliceText(d.restaurantDetails, 35)}
                                    </p>
                                  </div>
                                </div>
                              </a>
                              <hr />
                            </>
                          );
                        })}
                      {loadingSearch ? (
                        <div className="loading-text">Loading...</div>
                      ) : SearchData.searchFoodView.length === 0 &&
                        SearchData.searchRestaurantView.length === 0 ? (
                        <div className="d-flex justify-content-center">
                          <span>No Data Found</span>
                        </div>
                      ) : SearchData.searchFoodView.length > 3 ||
                        SearchData.searchRestaurantView.length > 2 ? (
                        <>
                          {SearchData.searchFoodView.length > 3 &&
                            SearchString && (
                              <div
                                className="d-flex justify-content-start ms-3"
                                onClick={handleSeeMoreClick}
                              >
                                <Link
                                  to="/food-search"
                                  state={SearchString}
                                  style={{ textDecoration: "none" }}
                                >
                                  <div className="Search-info-container">
                                    <div className="search-result-icon me-2">
                                      <img src={searchIcon} alt="search icon" />
                                    </div>
                                    <div className="search-term">
                                      Search for "{SearchString}" in food
                                    </div>
                                  </div>
                                </Link>
                              </div>
                            )}

                          {SearchData.searchRestaurantView.length > 2 &&
                            SearchString && (
                              <div
                                className="d-flex justify-content-start ms-3"
                                onClick={handleSeeMoreClick}
                              >
                                <Link
                                  to="/restaurant-search"
                                  state={SearchString}
                                  style={{ textDecoration: "none" }}
                                >
                                  <div className="Search-info-container">
                                    <div className="search-result-icon me-2">
                                      <img src={searchIcon} alt="search icon" />
                                    </div>
                                    <div className="search-term">
                                      Search for "{SearchString}" in restaurants
                                    </div>
                                  </div>
                                </Link>
                              </div>
                            )}
                        </>
                      ) : (
                        ""
                      )}
                      {/* {category === "" && (
                    <div className="pt-2">
                      <h5 style={{ fontWeight: "700" }}>Top Categories</h5>
                    </div>
                  )}
                  <div className="pt-2" style={{ marginLeft: "10px" }}>
                    <div className="d-flex flex-row ">
                      <img
                        src={search}
                        alt=""
                        style={{
                          width: "0.9rem",
                          height: "0.9rem",
                          marginRight: "1rem",
                          marginTop: "3px",
                        }}
                      />

                      <p style={{ fontSize: "14px", marginBottom: "0px" }}>
                        {category ? category : "Chinese"}
                      </p>
                    </div>
                    <hr />

                    <div className="d-flex flex-row">
                      <img
                        src={search}
                        alt=""
                        style={{
                          width: "0.9rem",
                          height: "0.9rem",
                          marginRight: "1rem",
                          marginTop: "3px",
                        }}
                      />
                      <p style={{ fontSize: "14px", marginBottom: "0px" }}>
                        {category ? "Cheese " + category : "Pizza"}
                      </p>
                    </div>
                    <hr />
                    <div className="d-flex flex-row">
                      <img
                        src={search}
                        alt=""
                        style={{
                          width: "0.9rem",
                          height: "0.9rem",
                          marginRight: "1rem",
                          marginTop: "3px",
                        }}
                      />
                      <p style={{ fontSize: "14px", marginBottom: "0px" }}>
                        {category ? "Normal " + category : "Pasta"}
                      </p>
                    </div>
                  </div> */}
                    </div>

                    {/* Food tab content - desktop */}
                    <div
                      class={`tab-pane fade ${
                        foodSelected ? "show active" : ""
                      } `}
                      id="food"
                      role="tabpanel"
                      aria-labelledby="profile-tab"
                    >
                      <p className="navbar_search-filter-label">
                        Top 5 Suggested Foods
                      </p>
                      {SearchData?.searchFoodView?.slice(0, 5)?.map((d, i) => {
                        return (
                          <>
                            <div
                              className="d-flex align-items-center pt-2"
                              style={{ minHeight: "2.5rem", cursor: "pointer" }}
                              onClick={() => {
                                foodItemGotClicked(d);
                              }}
                            >
                              {/* FoodItemImage for food tab */}
                              <div className="searchContentMargin">
                                <img
                                  src={d.itemImagePath}
                                  alt="img"
                                  className="searchDialogImg"
                                ></img>
                              </div>

                              {/* FoodItem name, restaurant name */}
                              <div className="d-flex flex-column searchContentMargin">
                                {/* Item Name, description, RestaurantName and ratings */}
                                <div className="searchText searchTitile d-flex gap-2">
                                  {/* Food Item Name */}
                                  <span>
                                    {highlightMatch(
                                      d.foodItemName,
                                      SearchString,
                                    )}{" "}
                                    <span
                                      style={{
                                        color: "gray",
                                        fontSize: "13px",
                                      }}
                                    >
                                      £{d.price}
                                    </span>
                                  </span>

                                  {/* FoodLabel */}
                                  <div className="searchLabel">
                                    <p className="searchText">Food</p>
                                  </div>

                                  {getFoodStatus(d.isActive, d.status) ===
                                    "Out of hour" && (
                                    <StatusCapsule
                                      status={getFoodStatus(
                                        d.isActive,
                                        d.status,
                                      )}
                                    />
                                  )}
                                </div>

                                {/* Food item rating */}
                                <div
                                  className="rating-Font d-flex gap-1 align-items-center starRating"
                                  data-bs-toggle="modal"
                                  data-bs-target="#staticBackdrop"
                                >
                                  <Rating
                                    className="ratingStar"
                                    initialRating={Number(4.5)}
                                    emptySymbol="far fa-star icon-color"
                                    fullSymbol="fas fa-star icon-color"
                                    readonly
                                  ></Rating>
                                  4.5
                                  <SearchDistanceLabel value={d.distance} hasLocation={Boolean(searchLocation)} />
                                </div>

                                {extractContext(d.description, SearchString) ? (
                                  <div className="d-flex flex-row">
                                    <p
                                      className="searchText searchratingText"
                                      style={{
                                        marginBottom: "0px",
                                        color: "#80615b",
                                      }}
                                    >
                                      {highlightMatch(
                                        extractContext(
                                          d.description,
                                          SearchString,
                                        ),
                                        SearchString,
                                      )}
                                    </p>
                                  </div>
                                ) : (
                                  <div className="d-flex flex-row">
                                    <p
                                      className="searchText searchratingText"
                                      style={{
                                        marginBottom: "0px",
                                        color: "#80615b",
                                      }}
                                    >
                                      {d.description.length > 100
                                        ? d.description.slice(0, 36) + "..."
                                        : d.description}
                                    </p>
                                  </div>
                                )}

                                {/* Restaurant Name for all Food */}
                                <div>
                                  <p
                                    className="searchText searchratingText d-flex flex-row gap-2"
                                    style={{
                                      marginBottom: "0px",
                                      color: "#80615b",
                                    }}
                                  >
                                    <span>{d.restaurantName}</span>
                                    <div style={{ marginTop: "-2px" }}>
                                      <StarRating
                                        starImage={star}
                                        rating={4.5}
                                      />
                                    </div>
                                  </p>
                                </div>
                              </div>

                              {/* <div className="searchLabel">
                        <p className="searchText">Food</p>
                      </div> */}
                              {
                                // d?.matchedText && <div className='searchLabel matched-text'>
                                //   <p className='searchText'>
                                //     {highlightMatch(sliceText(d?.matchedText?.split(",")[0], 15), SearchString)}
                                //   </p>
                                // </div>
                              }

                              {/* Showing matched field  */}
                              <div
                                className="d-flex gap-1 ml-2"
                                style={{ marginLeft: "auto", maxWidth: "40%" }}
                              >
                                {highlightMatch(d.foodItemName, SearchString)
                                  .length <= 1 &&
                                  !extractContext(
                                    d.description,
                                    SearchString,
                                  ) &&
                                  getMatchedColumn(d, SearchString).map(
                                    (matchedItem, index) => {
                                      const [key, value] =
                                        Object.entries(matchedItem)[0];
                                      return (
                                        <div
                                          className="ms-auto matched-text"
                                          key={index}
                                        >
                                          {/* Showing details header from db */}
                                          {key === "Details" && (
                                            <p className="mb-0">
                                              {d.foodDetailsHeader}
                                            </p>
                                          )}
                                          {/* If Instruction matched, then only show it */}
                                          {key === "Instruction" && (
                                            <p className="mb-0">
                                              {d.foodDetailsHeader}
                                            </p>
                                          )}

                                          {/* Else show header  */}
                                          {key !== "Details" &&
                                            key !== "Instruction" && (
                                              <p className="mb-0">{key}</p>
                                            )}
                                          <p className="mb-0">
                                            {highlightMatch(
                                              extractContext(
                                                value,
                                                SearchString,
                                              ),
                                              SearchString,
                                            )}
                                          </p>
                                        </div>
                                      );
                                    },
                                  )}
                              </div>
                            </div>
                            <hr />
                          </>
                        );
                      })}

                      {/* Search for modal */}
                      {loadingSearch ? (
                        <div className="loading-text">Loading...</div>
                      ) : SearchData.searchFoodView.length == 0 ? (
                        SearchData.searchRestaurantView.length > 0 ? (
                          <div
                            className="d-flex justify-content-start ms-3 mt-4"
                            onClick={() => {
                              const restaurantTabBtn = document.querySelector(
                                "[data-bs-target='#restaurant']",
                              );
                              if (restaurantTabBtn) {
                                restaurantTabBtn.click();
                              }
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <div className="Search-info-container">
                              <div className="search-result-icon me-2">
                                <img src={searchIcon} alt="search icon" />
                              </div>
                              <div className="search-term">
                                Search For "{SearchString}" in Restaurant
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="d-flex justify-content-center">
                            <span>No Data Found</span>
                            {/* <span>Go to res</span> */}
                          </div>
                        )
                      ) : SearchData.searchFoodView.length > 5 ? (
                        // &&
                        //   props.showSeeMore != false ?
                        <div
                          className="d-flex justify-content-start ms-3"
                          onClick={handleSeeMoreClick}
                        >
                          <Link
                            to="/food-search"
                            state={SearchString}
                            style={{ textDecoration: "none" }}
                          >
                            <div className="Search-info-container">
                              <div className="search-result-icon me-2">
                                <img src={searchIcon} alt="search icon" />
                              </div>
                              <div className="search-term">
                                Search for "{SearchString}"
                              </div>
                            </div>
                          </Link>
                        </div>
                      ) : (
                        ""
                      )}

                      {/* {category === "" && (
                    <div className="pt-2">
                      <h5 style={{ fontWeight: "700" }}>Top Categories</h5>
                    </div>
                  )}
                  <div className="pt-2" style={{ marginLeft: "10px" }}>
                    <div className="d-flex flex-row ">
                      <img
                        src={search}
                        alt=""
                        style={{
                          width: "0.9rem",
                          height: "0.9rem",
                          marginRight: "1rem",
                          marginTop: "3px",
                        }}
                      />

                      <p style={{ fontSize: "14px", marginBottom: "0px" }}>
                        {category ? category : "Chinese"}
                      </p>
                    </div>
                    <hr />

                    <div className="d-flex flex-row">
                      <img
                        src={search}
                        alt=""
                        style={{
                          width: "0.9rem",
                          height: "0.9rem",
                          marginRight: "1rem",
                          marginTop: "3px",
                        }}
                      />
                      <p style={{ fontSize: "14px", marginBottom: "0px" }}>
                        {category ? "Cheese " + category : "Pizza"}
                      </p>
                    </div>
                    <hr />
                    <div className="d-flex flex-row">
                      <img
                        src={search}
                        alt=""
                        style={{
                          width: "0.9rem",
                          height: "0.9rem",
                          marginRight: "1rem",
                          marginTop: "3px",
                        }}
                      />
                      <p style={{ fontSize: "14px", marginBottom: "0px" }}>
                        {category ? "Normal " + category : "Pasta"}
                      </p>
                    </div>
                  </div> */}
                    </div>

                    {/* Restaurant tab content - desktop */}
                    <div
                      class={`tab-pane fade ${
                        resturantSelected ? "show active" : ""
                      } `}
                      id="restaurant"
                      role="tabpanel"
                      aria-labelledby="contact-tab"
                    >
                      <p className="navbar_search-filter-label">
                        Top 5 Suggested Restaurants
                      </p>
                      {SearchData?.searchRestaurantView
                        ?.slice(0, 5)
                        ?.map((d, i) => {
                          return (
                            <>
                              <Link
                                to={`/${d.urlName}`}
                                state={d.urlName}
                                className="d-flex pt-2 align-items-center restaurant-link"
                              >
                                <div className="searchContentMargin">
                                  <img
                                    src={d.restaurantLogo}
                                    alt={`Logo of ${d.name}`}
                                    className="searchDialogImg"
                                  />
                                </div>

                                <div className="d-flex flex-column searchContentMargin">
                                  <span
                                    className="searchText searchTitile d-flex gap-2"
                                    style={{ textDecoration: "none" }}
                                  >
                                    <span>
                                      {highlightMatch(d.name, SearchString)}
                                    </span>
                                  </span>

                                  <div
                                    className="rating-Font d-flex gap-1 align-items-center starRating rating-color"
                                    data-bs-toggle="modal"
                                    data-bs-target="#staticBackdrop"
                                  >
                                    <Rating
                                      className="ratingStar"
                                      initialRating={Number(d.rating || 5)}
                                      emptySymbol="far fa-star icon-color"
                                      fullSymbol="fas fa-star icon-color"
                                      readonly
                                    />
                                    {d.rating || 5}
                                    <SearchDistanceLabel value={d.distanceInKm} hasLocation={Boolean(searchLocation)} />
                                  </div>

                                  <div className="d-flex flex-row">
                                    <p
                                      className="searchText searchratingText"
                                      style={{
                                        marginBottom: 0,
                                        color: "#80615b",
                                      }}
                                    >
                                      <span>
                                        {highlightMatch(
                                          d.restaurantCategories,
                                          SearchString,
                                        )}
                                      </span>
                                    </p>
                                  </div>

                                  <div>
                                    <p
                                      style={{
                                        marginBottom: 0,
                                        color: "#80615b",
                                        fontSize: "14px",
                                      }}
                                    >
                                      {sliceText(d.restaurantDetails, 35)}
                                    </p>
                                  </div>
                                </div>
                              </Link>
                              <hr />
                            </>
                            //     <>
                            //       <Link
                            //       to={`/${d.urlName}`}
                            //       state={d.urlName}
                            //         // href={`/${d.urlName}`}
                            //         className='d-flex pt-2 align-items-center restaurant-link'
                            //       >
                            //         {/* Restaurant Image */}
                            //         <div className='searchContentMargin'>
                            //           <img
                            //             src={d.restaurantLogo}
                            //             alt='img'
                            //             className='searchDialogImg'
                            //           ></img>
                            //         </div>

                            //         {/* Restaurant Details */}
                            //         <div className='d-flex flex-column searchContentMargin'>

                            //           {/* Restaurant Name and Rating */}
                            //           <span
                            //             className='searchText searchTitile d-flex gap-2'
                            //             style={{ textDecoration: 'none' }}
                            //           >
                            //             <span> {highlightMatch(d.name, SearchString)} </span>
                            //           </span>

                            //           {/* Ratings */}
                            //           <div
                            //             className='rating-Font d-flex gap-1 align-items-center starRating rating-color'
                            //             data-bs-toggle='modal'
                            //             data-bs-target='#staticBackdrop'
                            //           >
                            //             <Rating
                            //               className='ratingStar'
                            //               initialRating={Number(5)}
                            //               emptySymbol='far fa-star icon-color'
                            //               fullSymbol='fas fa-star icon-color'
                            //               readonly
                            //             ></Rating>
                            //             5
                            //           </div>

                            //           <div className='d-flex flex-row'>
                            //             <p
                            //               className='searchText searchratingText'
                            //               style={{
                            //                 marginBottom: '0px',
                            //                 color: '#80615b',
                            //               }}
                            //             >
                            //               <span>{highlightMatch(d.restaurantCategories, SearchString)}</span>
                            //             </p>
                            //           </div>

                            //           <div>
                            //             <p
                            //               style={{
                            //                 marginBottom: '0px',
                            //                 color: '#80615b',
                            //                 fontSize: '14px'
                            //               }}
                            //             >
                            //               {sliceText(d.restaurantDetails, 35)}
                            //             </p>
                            //           </div>

                            //         </div>

                            //         {/* <div className="searchLabelRestaurant">
                            //   <p className="searchText">Restaurant</p>
                            // </div> */}
                            //       </Link>
                            //       <hr />
                            //     </>
                          );
                        })}

                      {/* {category === "" && (
                    <div className="pt-2">
                      <h5 style={{ fontWeight: "700" }}>Top Categories</h5>
                    </div>
                  )}
                  <div className="pt-2" style={{ marginLeft: "10px" }}>
                    <div className="d-flex flex-row ">
                      <img
                        src={search}
                        alt=""
                        style={{
                          width: "0.9rem",
                          height: "0.9rem",
                          marginRight: "1rem",
                          marginTop: "3px",
                        }}
                      />

                      <p style={{ fontSize: "14px", marginBottom: "0px" }}>
                        {category ? category : "Chinese"}
                      </p>
                    </div>
                    <hr />

                    <div className="d-flex flex-row">
                      <img
                        src={search}
                        alt=""
                        style={{
                          width: "0.9rem",
                          height: "0.9rem",
                          marginRight: "1rem",
                          marginTop: "3px",
                        }}
                      />
                      <p style={{ fontSize: "14px", marginBottom: "0px" }}>
                        {category ? "Cheese " + category : "Pizza"}
                      </p>
                    </div>
                    <hr />
                    <div className="d-flex flex-row">
                      <img
                        src={search}
                        alt=""
                        style={{
                          width: "0.9rem",
                          height: "0.9rem",
                          marginRight: "1rem",
                          marginTop: "3px",
                        }}
                      />
                      <p style={{ fontSize: "14px", marginBottom: "0px" }}>
                        {category ? "Normal " + category : "Pasta"}
                      </p>
                    </div>
                  </div> */}
                      {loadingSearch ? (
                        <div className="loading-text">Loading...</div>
                      ) : SearchData.searchRestaurantView.length === 0 ? (
                        SearchData.searchFoodView.length > 0 ? (
                          <div
                            className="d-flex justify-content-start ms-3 mt-4"
                            onClick={() => {
                              const foodTabBtn = document.querySelector(
                                "[data-bs-target='#food']",
                              );
                              if (foodTabBtn) {
                                foodTabBtn.click();
                              }
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <div className="Search-info-container">
                              <div className="search-result-icon me-2">
                                <img src={searchIcon} alt="search icon" />
                              </div>
                              <div className="search-term">
                                Search For "{SearchString}" in Food
                              </div>
                            </div>
                          </div>
                        ) : (
                          // changing here
                          <div className="d-flex justify-content-center">
                            <span>No Data Found</span>
                          </div>
                        )
                      ) : SearchData.searchRestaurantView.length > 3 &&
                        SearchString ? (
                        // &&
                        //   props.showSeeMore != false ?
                        <div
                          className="d-flex justify-content-start ms-3"
                          onClick={handleSeeMoreClick}
                        >
                          <Link
                            to="/restaurant-search"
                            state={SearchString}
                            style={{ textDecoration: "none" }}
                          >
                            <div className="Search-info-container">
                              <div className="search-result-icon me-2">
                                <img src={searchIcon} alt="search icon" />
                              </div>
                              <div className="search-term">
                                Search for "{SearchString}"
                              </div>
                            </div>
                          </Link>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                    </>
                  )}
                </div>
              </div>
              </>,
              document.body,
            )
              : null}
            </div>

          {/* notification */}
          {/* <Notification /> */}
          {/* end notification */}

          {/* desktop notification, cart, Hello user and logout */}
          <div className="d-flex cart-design-with-login align-items-center">
            <div className={`${defaultColor ? "d-none" : ""}`}>
              <Cart />
            </div>

            <div className="login-Registration  d-flex align-items-center">
              {/* <div className={` dropdown dropdownBtn ${userVal !== "" ? "changeBtnDisplay" : ""} ${navbarOnTop ? "dropdown-color-white" : ""}`}>
                            <button className={`btn  dropdown-toggle btnLogin `} type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <div className='d-flex dropdown-Icons'>
                                    <img src={menuImg} alt="" style={{ width: "1.5rem", height: "1.5rem" }} />
                                    <img src={loginDesktopImg} alt="" style={{ width: "2rem" }} />
                                </div>

                            </button>
                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a className="dropdown-item dropdownItem" onClick={showModalInfo}>Login</a>
                                <a className="dropdown-item dropdownItem" href='/register' >Add Your Restaurant</a>
                            </div>

                        </div> */}

              {/* Hello, Username */}
              <span
                className={
                  "banner-signUp " +
                  (userVal !== "" ? "helloUserName" : "changeBtnDisplay ")
                }
              >
                <span style={{ color: navbarOnTop ? "white" : "black" }}>
                  Hello, {userVal}
                </span>
              </span>

              {/* Logout button */}
              <button
                type="button"
                className={
                  " btn btn-primary banner-signUp " +
                  (userVal !== "" ? "" : "changeBtnDisplay")
                }
                onClick={handleLogout}
              >
                <span style={{ color: navbarOnTop ? "white" : "black" }}>
                  Log Out
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Navbar for mobile device */}
      <div className="mobileDisplay">
        <div
          className={`navbarGoTaste ${
            navbarOnTop ? "backgroundTranparent" : "backgroundWhite"
          } ${slideUp ? "slideDown" : " slideUp "}`}
        >
          <button
            class="btn me-2"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasExample"
            aria-controls="offcanvasExample"
          >
            <i
              class={`fa-solid fa-bars text-light   ${
                navbarOnTop ? "text-light" : "text-dark"
              }`}
            ></i>
          </button>

          <div
            className="searchInput mobileDisplay"
            onClick={moibleSearchBarClicked}
          >
            <div
              className={` ${
                navbarOnTop
                  ? "search-field-color-white "
                  : "search-field-color-coffee "
              }search-field d-flex align-items-center`}
            >
              <button type="button" className="btn btn-search-Mobile">
                <div className="d-flex">
                  <div className="d-flex justify-content-center align-items-center">
                    <img
                      src={searchIcontCoffee}
                      alt=""
                      className="searchIconcoffee"
                      onClick={handleShow}
                    />
                  </div>
                  <div className="d-flex searchBtnText">
                    <b
                      className="text-muted searchForFood"
                      onClick={() => setSearchConditionOnClick()}
                    >
                      {searchLocation
                        ? `Search near ${locationLabel}`
                        : "Search food & restaurants"}
                    </b>
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* test end: iphone navbar issue */}

      {/* login window */}
      <div
        className="modal fade"
        id="exampleModalCenter"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header d-flex justify-content-between loginModalCloseBtn">
              {/* Back button for password view */}
              {passwordView && (
                <button
                  type="button"
                  className={"close-btn " + (isRegisterPage ? "d-none" : "")}
                  onClick={() => {
                    setPasswordView(false);
                    setisForgetPasswordSubmited(false);
                    dispatch(openRegisterPageFalse());
                  }}
                >
                  <span aria-hidden="true">
                    <img src={backBtn} alt="" style={{ width: "1.2rem" }} />
                  </span>
                </button>
              )}

              {/* Back button for forget password (before toggle) */}
              {forgetPassword && !forgetPasswordToggle && (
                <button
                  type="button"
                  className={"close-btn " + (isRegisterPage ? "d-none" : "")}
                  onClick={() => {
                    setforgetPassword(false);
                    setPasswordView(true);
                    setisForgetPasswordSubmited(false);
                    dispatch(closeForgetPassword());
                    dispatch(openRegisterPageFalse());
                  }}
                >
                  <span aria-hidden="true">
                    <img src={backBtn} alt="" style={{ width: "1.2rem" }} />
                  </span>
                </button>
              )}

              {/* Back button for forget password (after toggle active) */}
              {forgetPassword && forgetPasswordToggle && (
                <button
                  type="button"
                  className="close"
                  onClick={() => {
                    dispatch(closeForgetPassword());
                    setforgetPassword(false);
                  }}
                >
                  <span aria-hidden="true">
                    <img src={backBtn} alt="" style={{ width: "1.2rem" }} />
                  </span>
                </button>
              )}

              {/* Back button for Finish Signing Up */}
              {isRegisterPage && (
                <button
                  type="button"
                  className="close"
                  onClick={() => dispatch(openRegisterPageFalse())}
                >
                  <span aria-hidden="true">
                    <img src={backBtn} alt="" style={{ width: "1.2rem" }} />
                  </span>
                </button>
              )}

              {/* Cross button for main login/signup modal */}
              {!isRegisterPage && !forgetPassword && !passwordView && (
                <button
                  type="button"
                  className="close-btn styled-close"
                  onClick={hideModalInfo}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              )}

              {/* Header titles */}
              {forgetPassword && forgetPasswordToggle ? (
                <h5 className="modal-title" id="exampleModalLongTitle">
                  Forget Password
                </h5>
              ) : isRegisterPage ? (
                <div className="position-relative w-100 text-center">
                  <h5 className="modal-title m-0" id="exampleModalLongTitle">
                    Finish signing up
                  </h5>
                  <button
                    type="button"
                    className="close-btn position-absolute"
                    style={{
                      right: "0",
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                    onClick={() => {
                      hideModalInfo();
                      if (registerSuccess) {
                        window.location.reload();
                      }
                      setRegisterSuccess(false);
                    }}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              ) : (
                <h5 className="modal-title" id="exampleModalLongTitle">
                  Log in or sign up
                </h5>
              )}

              <span></span>
            </div>

            <div className="modal-body">
              {loginModalOpen ? (
                <Login
                  loaded="false"
                  userFound={handleUserFound}
                  userFoundFlag={passwordView}
                  forgetEmail={(props) => {
                    setforgetPassword(props);
                    setPasswordView(false);
                  }}
                  isRegisterPage={isRegisterPage}
                  isForgetPasswordSubmited={isForgetPasswordSubmited}
                  returnUrl={window.location.href}
                  onRegisterSuccess={() => setRegisterSuccess(true)}
                />
              ) : (
                "loading"
              )}
            </div>
          </div>
        </div>
      </div>

      {/* BottomNavigationBar */}
      <div className="mobileDisplay">
        <div
          className={`bottomBar ${
            show && showBottomBarDueToCartAddInSearch
              ? "forceVisibleInSearch"
              : slideUp
                ? "slideDownBottom"
                : "slideUpBottom"
          }`}
        >
          <div className="row align-items-center ">
            {/* Home Icon */}
            <div
              className="col-3 d-flex explore align-items-center"
              onClick={() => {
                goToHome();
              }}
            >
              <img src={logo} alt="" className="searchIconcoffeeHome" />
              <span>Home</span>
            </div>

            {/* Cart and Notification */}
            <div className="col-6 d-flex explore align-items-center ">
              {/* sdf */}
              <Cart usedIn={"bottomBar"} />
            </div>

            {/* User Icon */}
            <div className="col-3 d-flex explore align-items-center">
              <div
                onClick={showModalInfo}
                className={`d-flex explore align-items-center ${
                  userVal !== "" ? "d-none" : " changeBtnDisplay"
                }`}
              >
                <img src={loginImg} alt="" className="searchIconcoffee" />
                <span>Login</span>
              </div>
              <div
                className={`d-flex gap-1 explore align-items-center ${
                  userVal !== "" ? "" : "d-none"
                }`}
                onClick={handleMenuOpen}
              >
                <img
                  src={profileImage ? profileImage : userDefaultImg}
                  alt=""
                  className="profileImage"
                  style={{ borderRadius: "0px" }}
                />
                <span>{userVal}</span>
              </div>

              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                anchorOrigin={{
                  horizontal: "center",
                  vertical: "top",
                }}
                transformOrigin={{
                  horizontal: "center",
                  vertical: "bottom",
                }}
                MenuListProps={{
                  sx: {
                    paddingTop: 0,
                    paddingBottom: 0,
                  },
                }}
              >
                <MenuItem
                  onClick={handleLogout}
                  sx={{
                    "&:hover": {
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  Logout
                </MenuItem>
              </Menu>
            </div>
          </div>
        </div>
      </div>

      {/* Search Modal for mobile devices */}
      <Modal
        show={show}
        fullscreen="xxl-down"
        onHide={() => setShow(false)}
        className={`modalParentDiv search-modal-mobile${
          searchStep === "location"
            ? " search-modal-mobile--location"
            : " search-modal-mobile--results"
        }`}
        backdropClassName="search-modal-mobile-backdrop"
        contentClassName="search-modal-mobile-content"
      >
        <Modal.Body
          ref={modalBodyRef}
          className="search-modal-mobile-body"
          style={{
            paddingTop: "0px",
          }}
          onMouseDown={(event) => event.stopPropagation()}
        >
          <>
            <div className="search-modal-mobile-header">
              <Modal.Header className="p-0 border-0" closeButton />
            </div>

            <div
              className={`search-modal-mobile-stage${
                searchStep === "location"
                  ? " search-modal-mobile-stage--location"
                  : " search-modal-mobile-stage--results"
              }`}
            >
              <SearchStepNav
                currentStep={searchStep}
                locationLabel={locationLabel}
                searchKeyword={SearchString}
                onStepClick={handleStepClick}
                onSearchChange={handleInputChange}
                onClearSearch={handleClearSearch}
                inputRef={inputRef}
              />

            {searchStep === "location" ? (
                <SearchLocationStep
                  locationQuery={locationQuery}
                  onLocationQueryChange={setLocationQuery}
                  locationSuggestions={locationSuggestions}
                  loadingSuggestions={loadingSuggestions}
                  selectedLocation={searchLocation}
                  onSelectSuggestion={handleSelectLocation}
                  onClearSelection={handleClearLocationSelection}
                  onUseCurrentLocation={handleUseCurrentLocation}
                  loadingCurrentLocation={loadingCurrentLocation}
                  locationError={locationError}
                  onContinue={() => continueFromLocation({ mobile: true })}
                  onSkip={() => skipLocationStep({ mobile: true })}
                />
            ) : (
              <div className="search-modal-mobile-results">
            {/* Mobile view -- result tabs */}
            <div className="search-modal-mobile-results__tabs">
              <ul className="nav nav-tabs pt-2" id="myTabMobile" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${allSelected ? "active" : ""}`}
                    id="home-tab-mobile"
                    data-bs-toggle="tab"
                    data-bs-target="#all-mobile"
                    type="button"
                    role="tab"
                    aria-controls="all-mobile"
                    aria-selected={allSelected}
                    onClick={() => {
                      setAllSelected(true);
                      setFoodSelected(false);
                      setRestaurantSelected(false);
                    }}
                  >
                    All
                  </button>
                </li>

                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${foodSelected ? "active" : ""}`}
                    id="profile-tab-mobile"
                    data-bs-toggle="tab"
                    data-bs-target="#food-mobile"
                    type="button"
                    role="tab"
                    aria-controls="food-mobile"
                    aria-selected={foodSelected}
                    onClick={() => {
                      setAllSelected(false);
                      setFoodSelected(true);
                      setRestaurantSelected(false);
                    }}
                  >
                    Food
                  </button>
                </li>

                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${resturantSelected ? "active" : ""}`}
                    id="contact-tab-mobile"
                    data-bs-toggle="tab"
                    data-bs-target="#restaurant-mobile"
                    type="button"
                    role="tab"
                    aria-controls="restaurant-mobile"
                    aria-selected={resturantSelected}
                    onClick={() => {
                      setAllSelected(false);
                      setFoodSelected(false);
                      setRestaurantSelected(true);
                    }}
                  >
                    Restaurant
                  </button>
                </li>
              </ul>
            </div>

              {/* Tab Content */}
              <div
                className="tab-content scroll-bar search-modal-mobile-results__content"
                id="myTabContentMobile"
              >
                {/* Moblie view-all tab */}
                <div
                  className={`tab-pane fade ${
                    allSelected ? "show active" : ""
                  }  `}
                  id="all-mobile"
                  role="tabpanel"
                  aria-labelledby="home-tab-mobile"
                >
                  <p className="navbar_search-filter-label">
                    Top 5 Suggested Foods & Restaurants
                  </p>
                  {SearchData?.searchFoodView?.slice(0, 3)?.map((d, i) => {
                    return (
                      <>
                        <div
                          className="d-flex align-items-center pt-2"
                          style={{ minHeight: "2.5rem" }}
                          onClick={() => {
                            foodItemGotClicked(d);
                          }}
                        >
                          {/* FoodItem Image */}
                          <div className="searchContentMargin">
                            <img
                              src={d.itemImagePath}
                              alt="img"
                              className="searchDialogImg"
                            ></img>
                          </div>

                          <div className="d-flex flex-column searchContentMargin ">
                            <div className="searchText searchTitile d-flex gap-2">
                              <span>
                                {highlightMatch(d.foodItemName, SearchString)}
                                <span
                                  style={{
                                    color: "gray",
                                    fontSize: "13px",
                                    marginLeft: "5px",
                                  }}
                                >
                                  £{d.price}
                                </span>
                              </span>

                              {/* Food Pill */}
                              <div className="searchLabel">
                                <p className="searchText">Food</p>
                              </div>
                            </div>

                            <div className="d-flex align-items-center">
                              {/* Food item rating */}
                              <div
                                className="rating-Font d-flex gap-1 align-items-center starRating me-3 my-1"
                                data-bs-toggle="modal"
                                data-bs-target="#staticBackdrop"
                              >
                                <Rating
                                  className="ratingStar"
                                  initialRating={Number(4.5)}
                                  emptySymbol="far fa-star icon-color"
                                  fullSymbol="fas fa-star icon-color"
                                  readonly
                                ></Rating>
                                4.5
                                <SearchDistanceLabel value={d.distance} hasLocation={Boolean(searchLocation)} />
                              </div>

                              {getFoodStatus(d.isActive, d.status) ===
                                "Out of hour" && (
                                <StatusCapsule
                                  status={getFoodStatus(d.isActive, d.status)}
                                />
                              )}
                            </div>

                            {/* Fooditem description */}
                            {extractContext(d.description, SearchString) ? (
                              <div className="d-flex flex-row">
                                <p
                                  className="searchText searchratingText"
                                  style={{
                                    marginBottom: "0px",
                                    color: "#80615b",
                                  }}
                                >
                                  {highlightMatch(
                                    extractContext(d.description, SearchString),
                                    SearchString,
                                  )}
                                </p>
                              </div>
                            ) : (
                              <div className="d-flex flex-row">
                                <p
                                  className="searchText searchratingText"
                                  style={{
                                    marginBottom: "0px",
                                    color: "#80615b",
                                  }}
                                >
                                  {d.description.length > 100
                                    ? d.description.slice(0, 36) + "..."
                                    : d.description}
                                </p>
                              </div>
                            )}

                            {/* Restaurant Name for all tab */}
                            <div>
                              <p
                                className="searchText searchratingText d-flex flex-row gap-2"
                                style={{
                                  marginBottom: "0px",
                                  color: "#80615b",
                                }}
                              >
                                <span>{d.restaurantName}</span>
                                <div style={{ marginTop: "-2px" }}>
                                  <StarRating starImage={star} rating={4.5} />
                                </div>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div style={{ marginLeft: "50px" }}>
                          {highlightMatch(d.foodItemName, SearchString)
                            .length <= 1 &&
                            !extractContext(d.description, SearchString) &&
                            getMatchedColumn(d, SearchString).map(
                              (matchedItem, index) => {
                                const [key, value] =
                                  Object.entries(matchedItem)[0];
                                return (
                                  <div
                                    className="matched-text mt-3 ms-2"
                                    key={index}
                                  >
                                    {/* Showing details header from db */}
                                    {key === "Details" && (
                                      <p className="mb-0">
                                        {d.foodDetailsHeader}
                                      </p>
                                    )}
                                    {/* If Instruction matched, then only show it */}
                                    {key === "Instruction" && (
                                      <p className="mb-0">
                                        {d.foodDetailsHeader}
                                      </p>
                                    )}

                                    {/* Else show header  */}
                                    {key !== "Details" &&
                                      key !== "Instruction" && (
                                        <p className="mb-0">{key}</p>
                                      )}
                                    <p className="mb-0">
                                      {highlightMatch(
                                        extractContext(value, SearchString),
                                        SearchString,
                                      )}
                                    </p>
                                  </div>
                                );
                              },
                            )}
                        </div>
                        <hr style={{ marginBottom: "0px" }} />
                      </>
                    );
                  })}
                  {SearchData?.searchRestaurantView
                    ?.slice(0, 2)
                    ?.map((d, i) => {
                      return (
                        <>
                          <a
                            href={`/${d.urlName}`}
                            className="d-flex align-items-center pt-2 restaurant-link"
                            style={{ minHeight: "2.5rem" }}
                          >
                            <div className="searchContentMargin">
                              <img
                                src={d.restaurantLogo}
                                alt="img"
                                className="searchDialogImg"
                              ></img>
                            </div>
                            <div className="d-flex flex-column searchContentMargin">
                              <p className="searchText searchTitile d-flex gap-2">
                                <span>
                                  {highlightMatch(d.name, SearchString)}
                                </span>

                                {/* Restaurant pill */}
                                <div className="searchLabelRestaurant">
                                  <p className="searchText">Restaurant</p>
                                </div>
                              </p>
                              {/* restaurant rating */}
                              <div
                                className="rating-Font d-flex gap-1 align-items-center starRating rating-color"
                                data-bs-toggle="modal"
                                data-bs-target="#staticBackdrop"
                              >
                                <Rating
                                  className="ratingStar"
                                  initialRating={Number(4.5)}
                                  emptySymbol="far fa-star icon-color"
                                  fullSymbol="fas fa-star icon-color"
                                  readonly
                                ></Rating>
                                4.5
                                <SearchDistanceLabel value={d.distanceInKm} hasLocation={Boolean(searchLocation)} />
                              </div>

                              <div className="d-flex flex-row">
                                <p
                                  className="searchText searchratingText"
                                  style={{
                                    marginBottom: "0px",
                                    color: "#80615b",
                                  }}
                                >
                                  {highlightMatch(
                                    d.restaurantCategories,
                                    SearchString,
                                  )}
                                </p>
                              </div>

                              {/* Restaurant Details */}
                              <div className="d-flex flex-row">
                                <p
                                  className="searchText searchratingText"
                                  style={{
                                    marginBottom: "0px",
                                    color: "#80615b",
                                    fontWeight: "500",
                                  }}
                                >
                                  {d.restaurantDetails
                                    ? d.restaurantDetails.substring(0, 35) +
                                      "..."
                                    : ""}
                                </p>
                              </div>
                            </div>
                          </a>
                          <hr style={{ marginBottom: "0px" }} />
                        </>
                      );
                    })}
                  {loadingSearch ? (
                    <div className="loading-text">Loading...</div>
                  ) : SearchData.searchFoodView.length === 0 &&
                    SearchData.searchRestaurantView.length === 0 ? (
                    <div className="d-flex justify-content-center">
                      <span>No Data Found</span>
                    </div>
                  ) : SearchData.searchFoodView.length > 3 ||
                    SearchData.searchRestaurantView.length > 2 ? (
                    <>
                      {SearchData.searchFoodView.length > 3 && SearchString && (
                        <div
                          className="d-flex justify-content-start ms-3"
                          onClick={handleSeeMoreClick}
                        >
                          <Link
                            to="/food-search"
                            state={SearchString}
                            style={{ textDecoration: "none" }}
                          >
                            <div className="Search-info-container">
                              <div className="search-result-icon me-2">
                                <img src={searchIcon} alt="search icon" />
                              </div>
                              <div className="search-term">
                                Search for "{SearchString}" in food
                              </div>
                            </div>
                          </Link>
                        </div>
                      )}

                      {SearchData.searchRestaurantView.length > 2 &&
                        SearchString && (
                          <div
                            className="d-flex justify-content-start ms-3"
                            onClick={handleSeeMoreClick}
                          >
                            <Link
                              to="/restaurant-search"
                              state={SearchString}
                              style={{ textDecoration: "none" }}
                            >
                              <div className="Search-info-container">
                                <div className="search-result-icon me-2">
                                  <img src={searchIcon} alt="search icon" />
                                </div>
                                <div className="search-term">
                                  Search for "{SearchString}" in restaurants
                                </div>
                              </div>
                            </Link>
                          </div>
                        )}
                    </>
                  ) : (
                    ""
                  )}
                </div>

                {/* Moblie view-food tab */}
                <div
                  className={`tab-pane fade ${foodSelected ? "show active" : ""} `}
                  id="food-mobile"
                  role="tabpanel"
                  aria-labelledby="profile-tab-mobile"
                >
                  <p className="navbar_search-filter-label">
                    Top 5 Suggested Foods
                  </p>
                  {SearchData?.searchFoodView?.slice(0, 5)?.map((d, i) => {
                    return (
                      <>
                        <div
                          className="d-flex align-items-center pt-2"
                          style={{ minHeight: "2.5rem" }}
                          onClick={() => {
                            foodItemGotClicked(d);
                          }}
                        >
                          <div className="searchContentMargin">
                            <img
                              src={d.itemImagePath}
                              alt="img"
                              className="searchDialogImg"
                            ></img>
                          </div>
                          <div className="d-flex flex-column searchContentMargin">
                            <div className="searchText searchTitile d-flex gap-2">
                              <span>
                                {highlightMatch(d.foodItemName, SearchString)}
                                <span
                                  style={{
                                    color: "gray",
                                    fontSize: "13px",
                                    marginLeft: "5px",
                                  }}
                                >
                                  £{d.price}
                                </span>
                              </span>

                              {/* Food Pill */}
                              <div className="searchLabel">
                                <p className="searchText">Food</p>
                              </div>
                            </div>

                            {/* Food item rating */}
                            <div className="d-flex align-items-center">
                              <div
                                className="rating-Font d-flex gap-1 align-items-center starRating me-3 my-1"
                                data-bs-toggle="modal"
                                data-bs-target="#staticBackdrop"
                              >
                                <Rating
                                  className="ratingStar"
                                  initialRating={Number(4.5)}
                                  emptySymbol="far fa-star icon-color"
                                  fullSymbol="fas fa-star icon-color"
                                  readonly
                                ></Rating>
                                4.5
                                <SearchDistanceLabel value={d.distance} hasLocation={Boolean(searchLocation)} />
                              </div>

                              {getFoodStatus(d.isActive, d.status) ===
                                "Out of hour" && (
                                <StatusCapsule
                                  status={getFoodStatus(d.isActive, d.status)}
                                />
                              )}
                            </div>

                            {extractContext(d.description, SearchString) ? (
                              <div className="d-flex flex-row">
                                <p
                                  className="searchText searchratingText"
                                  style={{
                                    marginBottom: "0px",
                                    color: "#80615b",
                                  }}
                                >
                                  {highlightMatch(
                                    extractContext(d.description, SearchString),
                                    SearchString,
                                  )}
                                </p>
                              </div>
                            ) : (
                              <div className="d-flex flex-row">
                                <p
                                  className="searchText searchratingText"
                                  style={{
                                    marginBottom: "0px",
                                    color: "#80615b",
                                  }}
                                >
                                  {d.description.length > 100
                                    ? d.description.slice(0, 36) + "..."
                                    : d.description}
                                </p>
                              </div>
                            )}

                            {/* Restaurant Name for mobile view food tab */}
                            <div>
                              <p
                                className="searchText searchratingText d-flex flex-row gap-2"
                                style={{
                                  marginBottom: "0px",
                                  color: "#80615b",
                                }}
                              >
                                <span>{d.restaurantName}</span>
                                <div style={{ marginTop: "-2px" }}>
                                  <StarRating starImage={star} rating={4.5} />
                                </div>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div style={{ marginLeft: "50px" }}>
                          {highlightMatch(d.foodItemName, SearchString)
                            .length <= 1 &&
                            !extractContext(d.description, SearchString) &&
                            getMatchedColumn(d, SearchString).map(
                              (matchedItem, index) => {
                                const [key, value] =
                                  Object.entries(matchedItem)[0];
                                return (
                                  <div
                                    className="matched-text mt-3 ms-2"
                                    key={index}
                                  >
                                    {/* Showing details header from db */}
                                    {key === "Details" && (
                                      <p className="mb-0">
                                        {d.foodDetailsHeader}
                                      </p>
                                    )}
                                    {/* If Instruction matched, then only show it */}
                                    {key === "Instruction" && (
                                      <p className="mb-0">
                                        {d.foodDetailsHeader}
                                      </p>
                                    )}

                                    {key !== "Details" &&
                                      key !== "Instruction" && (
                                        <p className="mb-0">{key}</p>
                                      )}
                                    <p className="mb-0">
                                      {highlightMatch(
                                        extractContext(value, SearchString),
                                        SearchString,
                                      )}
                                    </p>
                                  </div>
                                );
                              },
                            )}
                        </div>
                        <hr style={{ marginBottom: "0px" }} />
                      </>
                    );
                  })}
                  {loadingSearch ? (
                    <div className="loading-text">Loading...</div>
                  ) : SearchData.searchFoodView.length == 0 ? (
                    SearchData.searchRestaurantView.length > 0 ? (
                      <div
                        className="d-flex justify-content-start ms-3 mt-4"
                        onClick={() => {
                          const restaurantTabBtn = document.querySelector(
                            "[data-bs-target='#restaurant']",
                          );
                          if (restaurantTabBtn) {
                            restaurantTabBtn.click();
                          }
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="Search-info-container">
                          <div className="search-result-icon me-2">
                            <img src={searchIcon} alt="search icon" />
                          </div>
                          <div className="search-term">
                            Search For "{SearchString}" in Restaurant
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="d-flex justify-content-center">
                        <span>No Data Found</span>
                      </div>
                    )
                  ) : SearchData.searchFoodView.length > 5 ? (
                    <div
                      className="d-flex justify-content-start ms-3"
                      onClick={handleSeeMoreClick}
                    >
                      <Link
                        to="/food-search"
                        state={SearchString}
                        style={{ textDecoration: "none" }}
                      >
                        <div className="Search-info-container">
                          <div className="search-result-icon me-2">
                            <img src={searchIcon} alt="search icon" />
                          </div>
                          <div className="search-term">
                            Search for "{SearchString}"
                          </div>
                        </div>
                      </Link>
                    </div>
                  ) : (
                    ""
                  )}
                </div>

                {/* Moblie view-restaurant tab */}
                <div
                  className={`tab-pane fade ${
                    resturantSelected ? "show active" : ""
                  } `}
                  id="restaurant-mobile"
                  role="tabpanel"
                  aria-labelledby="contact-tab-mobile"
                >
                  <p className="navbar_search-filter-label">
                    Top 5 Suggested Restaurants
                  </p>
                  {SearchData?.searchRestaurantView
                    ?.slice(0, 5)
                    ?.map((d, i) => {
                      return (
                        <>
                          <a
                            href={`/${d.urlName}`}
                            className="d-flex align-items-center pt-2 restaurant-link"
                            style={{ minHeight: "2.5rem" }}
                          >
                            <div className="searchContentMargin">
                              <img
                                src={d.restaurantLogo}
                                alt="img"
                                className="searchDialogImg"
                              ></img>
                            </div>
                            <div className="d-flex flex-column searchContentMargin">
                              <span className="searchText searchTitile d-flex gap-2">
                                <span>
                                  {highlightMatch(d.name, SearchString)}
                                </span>
                              </span>

                              {/* Restaurant rating */}
                              <div
                                className="rating-Font d-flex gap-1 align-items-center starRating rating-color"
                                data-bs-toggle="modal"
                                data-bs-target="#staticBackdrop"
                              >
                                <Rating
                                  className="ratingStar"
                                  initialRating={Number(4.5)}
                                  emptySymbol="far fa-star icon-color"
                                  fullSymbol="fas fa-star icon-color"
                                  readonly
                                ></Rating>
                                4.5
                                <SearchDistanceLabel value={d.distanceInKm} hasLocation={Boolean(searchLocation)} />
                              </div>

                              <div className="d-flex flex-row">
                                <p
                                  className="searchText searchratingText"
                                  style={{
                                    marginBottom: "0px",
                                    color: "#80615b",
                                  }}
                                >
                                  {highlightMatch(
                                    d.restaurantCategories,
                                    SearchString,
                                  )}
                                </p>
                              </div>

                              {/* Restaurant Details */}
                              <div className="d-flex flex-row">
                                <p
                                  className="searchText searchratingText"
                                  style={{
                                    marginBottom: "0px",
                                    color: "#80615b",
                                    fontWeight: "500",
                                  }}
                                >
                                  {d.restaurantDetails
                                    ? d.restaurantDetails.substring(0, 35) +
                                      "..."
                                    : ""}
                                </p>
                              </div>
                            </div>
                          </a>
                          <hr style={{ marginBottom: "0px" }} />
                        </>
                      );
                    })}

                  {loadingSearch ? (
                    <div className="loading-text">Loading...</div>
                  ) : SearchData.searchRestaurantView.length === 0 ? (
                    SearchData.searchFoodView.length > 0 ? (
                      <div
                        className="d-flex justify-content-start ms-3 mt-4"
                        onClick={() => {
                          const foodTabBtn = document.querySelector(
                            "[data-bs-target='#food']",
                          );
                          if (foodTabBtn) {
                            foodTabBtn.click();
                          }
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="Search-info-container">
                          <div className="search-result-icon me-2">
                            <img src={searchIcon} alt="search icon" />
                          </div>
                          <div className="search-term">
                            Search For "{SearchString}" in Food
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="d-flex justify-content-center">
                        <span>No Data Found</span>
                      </div>
                    )
                  ) : SearchData.searchFoodView.length > 5 ? (
                    <div
                      className="d-flex justify-content-start ms-3"
                      onClick={handleSeeMoreClick}
                    >
                      <Link
                        to="/restaurant-search"
                        state={SearchString}
                        style={{ textDecoration: "none" }}
                      >
                        <div className="Search-info-container">
                          <div className="search-result-icon me-2">
                            <img src={searchIcon} alt="search icon" />
                          </div>
                          <div className="search-term">
                            Search for "{SearchString}"
                          </div>
                        </div>
                      </Link>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            )}
            </div>
          </>
        </Modal.Body>
      </Modal>

      <SidebarLogin loginClick={showModalInfo}></SidebarLogin>

      {showModalCard && (
        <FoodModal
          show={showModalCard}
          handleClose={handleClose}
          orderDetails={orderDetails}
          selectedItemImage={selectedItemImage}
          selectedItemId={selectedItemId}
          selectedIndex={selectedImageIndex}
          showUnavailableReasonModal={showUnavailableReasonModal}
          setShowUnavailableReasonModal={setShowUnavailableReasonModal}
          showOutOfHourModal={showOutOfHourModal}
          setShowOutOfHourModal={setShowOutOfHourModal}
          foodDatarestaurant={true}
          onAfterSaveInSearch={() => {
            if (showRef.current) {
              setShowBottomBarDueToCartAddInSearch(true);
            }
          }}
        />
      )}

      {showUpdateFoodModalCard && (
        <FoodModalUpdate
          show={showEdit}
          handleClose={closeEditModal}
          orderDetails={orderDetailsEdit}
          selectedItemImage={selectedItemImageEdit}
          selectedItemId={selectedItemIdEdit}
          cart={cartData}
          loading={editLoading}
        />
      )}
    </div>
  );
};

export default Navbar;
